import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import SortHealthInsureProduct from "../../Components/Modals/SortHealthInsureProduct";
import "../../Assets/css/listOfProducts.css";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import useSelectedProductCard from "../../PersonalAccident/ProductListingPage/useSelectedProductCard";
import ProductCard from "../../Components/PersonalAccidentComponents/ProductCard/ProductCard";
import ProductCardSkeleton from "../../Components/PersonalAccidentComponents/ProductCard/ProductCardSkeleton";
import NoProductFound from "../../Components/PersonalAccidentComponents/NoProductFound/NoProductFound";
import useListOfProducts from "./useListOfProducts";
import SocketConnectionState from "./Helpers/socketConnectionState";
import SignIn from "../../AcuvisorCustomerApp/components/userAuth/SignIn";

const ListOfProducts = () => {
  const {
    socketConnectionState,
    sortByPremium,
    handleSort,
    handleSearch,
    handleCloseSort,
    dialogState,
    productList,
    getPolicy,
    goBack,
    openSignIn
  } = useListOfProducts();

  // Handles the selection of product card
  const { activeIndex, handleSelectProductCard } = useSelectedProductCard();

  return (
    <div className="">
      <div className="">
        <CategoryHeader title="Plan Suggested For You" />
      </div>
      <div>
        <div className="form-container mb-3">
          <div className="searchbox_container">
            <div className="search_box">
              <SearchIcon className="searchIcon"></SearchIcon>
              <input
                type="search"
                className="input_searchbox"
                placeholder="Search for plans"
                onChange={(val) => handleSearch(val)}
              />
            </div>

            <button className="sort_btn" onClick={handleSort}>
              sort
            </button>

            <SortHealthInsureProduct
              open={dialogState}
              close={handleCloseSort}
              sortByPremium={sortByPremium}
            />
          </div>
          {openSignIn && <SignIn defaultOpen={true} />}
          {/* All Products */}
          {productList.map((item, index) => (
            <ProductCard
              product={item}
              key={item?.Acuvisor_product_id || index}
              onClick={() => handleSelectProductCard(index)}
              isActive={index === activeIndex}
            />
          ))}
          {/* No products available */}
          {(socketConnectionState === SocketConnectionState.DISCONNECTED ||
            socketConnectionState === SocketConnectionState.ERROR) &&
            productList.length === 0 && <NoProductFound />}
          {/* Shimmer effect */}
          {socketConnectionState !== SocketConnectionState.DISCONNECTED &&
            [1, 2, 3, 4].map((index) => <ProductCardSkeleton key={index} />)}
        </div>

        <div className=" btn-sec position-fixed bottom-0  ">
          <button
            className="Goback_btn text-capitalize"
            onClick={() => goBack()}
          >
            Go back
          </button>

          <button
            className="submitBtn text-capitalize"
            onClick={() => getPolicy(activeIndex)}
            disabled={activeIndex === undefined ? true : false}
          >
            Buy Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ListOfProducts;
